import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, output } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import type { SubscriptionBannerTypeOptions } from './subscription-banner.types';
import type { IconName } from '../../icons-container/icons.type';
import { IconButtonComponent } from '../button/components/icon-button/icon-button.component';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'rt-subscription-banner',
  templateUrl: './subscription-banner.component.html',
  styleUrls: ['./subscription-banner.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, IconComponent, RouterLink, IconButtonComponent],
})
export class SubscriptionBannerComponent {
  @Input() public type: SubscriptionBannerTypeOptions;
  @Input() public iconName: IconName;
  @Input() public message: string;
  @Input() public linkUrl: any[];
  @Input() public linkText: null | string;
  @Input() public linkBold: boolean;
  @Input() public contactText?: string;

  @Input() public isDismissible: boolean;

  public linkClick = output<void>();
  public closeBanner = output<MouseEvent>();

  public router = inject(Router);

  public onCloseClick(event: MouseEvent) {
    this.closeBanner.emit(event);
  }

  public get bannerMessage() {
    return this.message + (this.contactText ? ' ' + this.contactText : '');
  }
}
